<template>
  <div class="feature-info-container default-info-card"
    v-if="dataList.length > 0"
  >
    <div class="feature-info-control">
      <svg-icon iconName="el-Close"
        @click="dataListClose()"
      ></svg-icon>
    </div>
    <el-scrollbar max-height="16.875rem">
      <div class="feature-info-item"
        v-for="(item, index) of dataList"
        :key="index"
        @click="featureInfoClick(item)"
      >
        <div
          class="feature-info-item-attr"
          v-for="(key, keyIndex) of getItemKeys(item)"
          :key="keyIndex"
          @mouseover="mouseoverFn($event, item)"
          @mouseout="mouseoutFn($event, item)"
        >
          <div class="feature-info-attr-key ellipsis"
            :title="key"
          >
            {{ key }}
          </div>
          <div class="feature-info-attr-value">
            {{ item[key] }}
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw,
} from 'vue';
import store from '@/store';

import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { queryFeatureInfo, } from '@/api/MapManage';
import { feature } from '@turf/turf';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

const homeMap = computed(()=> store.getters['getHomeMap'] ),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      },
      tileMap = computed(()=> store.getters['homeTile/tileMap'] ),
      tileIds = computed(()=> Array.from(tileMap.value.keys()) );

const dataList = ref([]), dataListClose = ()=>{
  dataList.value.splice(0);
}

const featureInfoClick = (item)=>{
  console.log(item);
  const { layer } = item;
  const bounds = layer && layer.getBounds();
  bounds && bounds.isValid() && map.fitBounds(bounds);
}

const mouseoverFn = (event, item)=>{
  // console.log(event, item);
  const layer = item['layer'];
  layer && layerGroup.addLayer(layer);
}

const mouseoutFn = (event, item)=>{
  // console.log(event, item);
  const layer = item['layer'];
  layer && layerGroup.removeLayer(layer);
}

const getItemKeys = (item)=>{
  const checkArr = [ 'geom', 'layer', ];
  return Object.keys(item).filter(key=>{
    return !checkArr.includes(key);
  });
}

const featureLayerInit = (list)=>{
  layerGroupClear();
  list.forEach(item=>{
    const json = JSON.parse(item['geom']);
    item['layer'] = L.geoJSON(json);
  })
}

const featureInfoRequest = (click)=>{
  // console.log(click);
  if(tileIds.value.length == 0)return;
  queryFeatureInfo({
    mapId: tileIds.value.at(-1),
    lon: click.latlng.lng,
    lat: click.latlng.lat,
  }).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.data;
      featureLayerInit(res.data.data);
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  map.on('click', featureInfoRequest);
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
  map.off('click', featureInfoRequest);
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.feature-info-container{
  position: absolute;
  top: 10px;
  left: calc(var(--nav-panel-width) + 20px);
  width: 260px;
  // height: 300px;
  transition: left 0.4s;
  .feature-info-control{
    text-align: right;
    .svg-icon{
      font-size: 14px;
      cursor: pointer;
    }
  }
  .feature-info-item{
    border-bottom: 1px solid var(--borderColor_2);
    padding: 5px;
    &:hover{
      background-color: rgba(33, 88, 233, 0.2);
      border-radius: 5px;
    }
    .feature-info-item-attr{
      display: flex;
      font-size: 16px;
      .feature-info-attr-key{
        width: 80px;
        color: var(--fontColor_18);
      }
      .feature-info-attr-value{
        flex: 1;
        min-width: 0;
        color: var(--fontColor_24);
      }
    }
  }
}
</style>